import React from 'react';
import { ColGroupDef, ValueFormatterParams } from 'ag-grid-community';
import { Icon } from 'semantic-ui-react';
import { getFundsDesignationTextByValue } from 'erisxkit/client';
import FinanceAccount from '../../../ts/models/FinanceAccount.model';

const DEFAULT_ASSET_TYPE = 'USD';

const getColumnDefs = (
  onSelectAccount: (accountId: string) => void,
): ColGroupDef<FinanceAccount>[] => [
  {
    headerName: 'Identity',
    children: [
      {
        headerName: 'Firm Code',
        field: 'firmCode',
        filter: 'agMultiColumnFilter',
        initialWidth: 180,
      },
      {
        headerName: 'Account Code',
        field: 'accountCode',
        filter: 'agMultiColumnFilter',
        initialWidth: 180,
      },
      {
        headerName: 'Account Name',
        field: 'name',
        filter: 'agMultiColumnFilter',
        initialWidth: 180,
      },
      {
        headerName: 'Subexchange',
        field: 'subExchangeLabel',
        filter: 'agMultiColumnFilter',
        initialWidth: 180,
      },
      {
        headerName: 'Provider',
        field: 'provider',
        filter: 'agMultiColumnFilter',
        initialWidth: 180,
      },
      {
        headerName: 'Provider Account Id',
        field: 'providerAccountId',
        filter: 'agMultiColumnFilter',
        initialWidth: 220,
      },
      {
        headerName: 'Funds Designation',
        field: 'fundsDesignation',
        filter: 'agMultiColumnFilter',
        initialWidth: 200,
        valueFormatter: ({ data }: ValueFormatterParams<FinanceAccount>) => {
          const fundsDesignation = data?.fundsDesignation;
          return (
            getFundsDesignationTextByValue(fundsDesignation) || fundsDesignation
          );
        },
      },
    ],
  },
  {
    headerName: 'Balance',
    children: [
      {
        headerName: 'Asset Type',
        field: 'assetType',
        filter: 'agMultiColumnFilter',
        initialWidth: 180,
        valueGetter: ({ data }: { data?: FinanceAccount }) => {
          const balances = data?.balances;
          const assetType = data?.assetType;
          const defaultAmount =
            balances && balances[DEFAULT_ASSET_TYPE.toLowerCase()]
              ? balances[DEFAULT_ASSET_TYPE.toLowerCase()]
              : '';
          if (assetType) {
            return assetType;
          }
          if (defaultAmount) {
            return DEFAULT_ASSET_TYPE;
          }
        },
      },
      {
        headerName: 'Amount',
        field: 'amount',
        initialWidth: 180,
        valueGetter: ({ data }: { data?: FinanceAccount }) => {
          const balances = data?.balances;
          const assetType = data?.assetType?.toLowerCase();
          const defaultAmount = balances
            ? balances[DEFAULT_ASSET_TYPE.toLowerCase()]
            : '';
          const amount = balances && assetType ? balances[assetType] : '';
          if (!assetType) {
            return defaultAmount;
          }
          return amount;
        },
        filter: 'agMultiColumnFilter',
      },
      {
        headerName: 'Actions',
        initialWidth: 140,
        cellRenderer: ({ data }: ValueFormatterParams<FinanceAccount>) => {
          return (
            <span>
              {
                <Icon
                  link
                  title="View Reconciliation History"
                  onClick={() => {
                    onSelectAccount(data?.accountId || '');
                  }}
                  color="grey"
                  name="arrow alternate circle right outline"
                />
              }
            </span>
          );
        },
      },
    ],
  },
];

export default getColumnDefs;
